module.exports = __webpack_public_path__ + "img/file-download-20x20.c4b36e9a.svg";